import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { captureTenantKey } from "@/lib/tenant";
import { captureHandoffToken, resolveHandoffAtBoot } from "@/lib/handoff";

// §tenant session isolation: capture (or clear) the ?t= tenant key SYNCHRONOUSLY
// before first render, so header/home links can read it via buildTenantUrl() on
// their initial paint and preserve ?t= across navigation.
captureTenantKey();

// §authenticated-patient handoff: capture the ?pt= token synchronously, then —
// only when one is present — resolve it to the real patient BEFORE first render
// so the forms can synchronously prefill + skip the contact/OTP step on their
// initial paint. Anonymous visitors (no ?pt=) render immediately, unchanged.
// resolveHandoffAtBoot never throws — a resolve failure degrades to normal flow.
const root = ReactDOM.createRoot(document.getElementById("root"));
const renderApp = () =>
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

if (captureHandoffToken()) {
  // Resolve before first render so forms can prefill + skip the contact step on
  // their initial paint — but cap the wait so a slow/hung BE can never white-
  // screen an embedded launch. On timeout we render the normal flow (the resolve
  // still finishes in the background; a late success just isn't reflected).
  const RESOLVE_BUDGET_MS = 6000;
  let rendered = false;
  const renderOnce = () => { if (!rendered) { rendered = true; renderApp(); } };
  const timer = setTimeout(renderOnce, RESOLVE_BUDGET_MS);
  resolveHandoffAtBoot().finally(() => { clearTimeout(timer); renderOnce(); });
} else {
  renderApp();
}
